import { addDays, format, parse, startOfDay, startOfWeek } from 'date-fns';
import { DATE_FORMAT_ISO_DAY } from '../../constants/dateFormat';
import { fr } from 'date-fns/locale';
import { CalendarGranularity } from './types';

export type CalendarDayLabel = Readonly<{
    day_of_month: string;
    weekday_short: string;
    day_and_month: string;
    long_weekday_date: string;
    full_date: string;
}>;

function capitalizeWeekday(weekday: string): string {
    const trimmed = weekday.replace(/\.+$/, '');
    return trimmed.charAt(0).toLocaleUpperCase('fr') + trimmed.slice(1);
}

function parseYmd(ymd: string): Date {
    return startOfDay(parse(ymd, DATE_FORMAT_ISO_DAY, new Date()));
}

export function buildCalendarPeriodLabel(anchor: Date, granularity: CalendarGranularity): string {
    const day = startOfDay(anchor);
    if (granularity === CalendarGranularity.Week) {
        const from = startOfWeek(day, { weekStartsOn: 1 });
        const to = addDays(from, 6);
        return `${format(from, 'd MMM', { locale: fr })} \u2013 ${format(to, 'd MMM yyyy', { locale: fr })}`;
    }
    if (granularity === CalendarGranularity.Day) {
        return format(day, 'EEEE d MMMM yyyy', { locale: fr });
    }
    return format(day, 'MMMM yyyy', { locale: fr });
}

export function buildCalendarDayLabels(
    datesYmd: readonly string[],
): Readonly<Record<string, CalendarDayLabel>> {
    const map: Record<string, CalendarDayLabel> = {};
    for (const ymd of datesYmd) {
        const day = parseYmd(ymd);
        map[ymd] = {
            day_of_month: format(day, 'd', { locale: fr }),
            weekday_short: capitalizeWeekday(format(day, 'EEE', { locale: fr })),
            day_and_month: format(day, 'd MMM', { locale: fr }),
            long_weekday_date: format(day, 'EEEE d MMMM', { locale: fr }),
            full_date: format(day, 'EEEE d MMMM yyyy', { locale: fr }),
        };
    }
    return map;
}
